import { render, staticRenderFns } from "./SegmentButton.vue?vue&type=template&id=e957e8ac&scoped=true&"
import script from "./SegmentButton.vue?vue&type=script&lang=js&"
export * from "./SegmentButton.vue?vue&type=script&lang=js&"
import style0 from "./SegmentButton.vue?vue&type=style&index=0&id=e957e8ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e957e8ac",
  null
  
)

export default component.exports